/* screens/workspace/feed/CanvasHost.jsx — диспетчер inline-канвасов (S6).
   canvasSpecFromMeta(md) → выводит спеку канваса из metadata сообщения:
     md.canvas = { type, id, progressive?, partial? }  — явная форма (предпочтительно)
     либо обратная совместимость: ttk_id → ttk, menu_id → menu, report_id → тип отчёта;
     либо md.pending_changes → { type:'change', pc } — канвас изменений СУЩЕСТВУЮЩЕЙ
     сущности на одобрение (AI-правка через propose_*_edit; pc лежит в metadata
     целиком, загрузка не нужна — авто-открытие и в живом стриме, и из истории).
   Тип отчёта берётся из metadata.report_type (бэк кладёт его при материализации
   отчёта, chats/tools/heavy.py), поэтому id→тип резолвить не нужно — делегируем
   общему адаптеру adaptCanvasSpec (раньше тут читался мок-стор reports.js, из-за чего
   в проде foodcost/inventory-канвасы всегда падали в 'abc').
   CanvasHost({ spec, onClose, panel }) рендерит нужный из 6 канвасов.
   ХЕНДОФФ → frontend/components/chat/MessageList.jsx (логика вставки канваса). */

import { adaptCanvasSpec } from '../../../lib/adapters/chats.js';
import { ABCCanvas } from '../canvas/ABCCanvas.jsx';
import { ChangeCanvas } from '../canvas/ChangeCanvas.jsx';
import { FoodcostCanvas } from '../canvas/FoodcostCanvas.jsx';
import { InventoryCanvas } from '../canvas/InventoryCanvas.jsx';
import { MenuCanvas } from '../canvas/MenuCanvas.jsx';
import { TTKCanvas } from '../canvas/TTKCanvas.jsx';

  // Без второго аргумента adaptCanvasSpec берёт тип отчёта из metadata.report_type.
  function canvasSpecFromMeta(md) {
    const spec = adaptCanvasSpec(md);
    if (spec) return spec;
    // AI-правка существующей сущности: показываем канвас изменений по последней
    // pending-правке сообщения (обычно она одна на ход; компакт-карточку
    // ConfirmActionCard на это время прячет MessageList).
    const pcs = md && Array.isArray(md.pending_changes) ? md.pending_changes : [];
    if (pcs.length) {
      const pc = pcs[pcs.length - 1];
      if (pc && pc.id != null) return { type: 'change', pc };
    }
    return null;
  }

  function CanvasHost({ spec, onClose, panel }) {
    if (!spec) return null;
    const map = {
      ttk: TTKCanvas, menu: MenuCanvas, abc: ABCCanvas,
      foodcost: FoodcostCanvas, inventory: InventoryCanvas,
      change: ChangeCanvas,
    };
    const C = map[spec.type];
    if (!C) return null;
    // key по правке/сущности: смена spec.pc (вторая правка в том же ходе)
    // обязана РЕМОУНТИТЬ канвас — иначе useState-статус (committed/restoreRef)
    // прежней правки утёк бы в диф новой (вплоть до «Откатить» чужой сущности).
    const key = spec.type === 'change'
      ? 'pc-' + (spec.pc && spec.pc.id)
      : spec.type + '-' + (spec.id != null ? spec.id : 'live');
    return <C key={key} spec={spec} onClose={onClose} panel={panel} />;
  }

export { canvasSpecFromMeta };
export { CanvasHost };
